import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { SharedRelatedItemsSection } from '../SharedRelatedItemsSection/SharedRelatedItemsSection.tsx';
import { youMayAlsoLike as youMayAlsoLikeHeader } from '../sharedMessages.jsx';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy.ts';

import { type SharedYMAL_viewer$key } from './__generated__/SharedYMAL_viewer.graphql.ts';
import { type SharedYMAL_itemSearch$key } from './__generated__/SharedYMAL_itemSearch.graphql.ts';
import { type SharedYMAL_user$key } from './__generated__/SharedYMAL_user.graphql.ts';

const viewerFragment = graphql`
    fragment SharedYMAL_viewer on Viewer {
        ...SharedRelatedItemsSection_viewer
    }
`;

const itemSearchFragment = graphql`
    fragment SharedYMAL_itemSearch on ItemSearchQueryConnection {
        pageType
        ...SharedRelatedItemsSection_itemSearch
        youMayAlsoLike(first: 20) {
            edges {
                node {
                    item {
                        ...SharedRelatedItemsSection_item
                    }
                }
            }
        }
    }
`;

const userFragment = graphql`
    fragment SharedYMAL_user on User {
        ...SharedRelatedItemsSection_user
    }
`;

type Props = {
    viewer: SharedYMAL_viewer$key;
    itemSearch: SharedYMAL_itemSearch$key;
    user: SharedYMAL_user$key;
    isMobile?: boolean;
};

const SharedYMAL: FC<Props> = ({
    viewer: viewerRef,
    itemSearch: itemSearchRef,
    user: userRef,
    isMobile,
}) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const user = useFragment(userFragment, userRef);

    const { youMayAlsoLike, pageType } = itemSearch;
    const items = youMayAlsoLike?.edges?.map(edge => edge?.node?.item).filter(filterFalsy) || [];

    return (
        <SharedRelatedItemsSection
            viewer={viewer}
            itemSearch={itemSearch}
            items={items}
            user={user}
            header={youMayAlsoLikeHeader}
            initialRowCount={isMobile ? 4 : 2}
            list={`${pageType} you may also like`}
        />
    );
};

export default SharedYMAL;
